import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedProjectsShowIssuesRoute extends BaseRoute {}
